<template>
    <div>
        <v-card height="340px">
            <v-toolbar outlined flat style="height: 60px">
                <v-toolbar-title>
                    <v-subheader class="text-caption text-uppercase font-weight-bold primary--text pl-0">{{graph.name}}</v-subheader>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div v-if="graph.props[0]==='kwht'">
                    <v-btn text x-small v-model="kwh.btn0" :color="kwh.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="kwh.btn1" :color="kwh.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="kwh.btn2" :color="kwh.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                    <v-btn text x-small v-model="kwh.btn3" :color="kwh.btn3 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[3])"> {{ items[3] }} </v-btn>
                </div>
                <div v-if="graph.props[0]==='watts'">
                    <v-btn text x-small v-model="w.btn0" :color="w.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="w.btn1" :color="w.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="w.btn2" :color="w.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                </div>
                <div v-if="graph.props[0]==='volts'">
                    <v-btn text x-small v-model="v.btn0" :color="v.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="v.btn1" :color="v.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="v.btn2" :color="v.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                </div>
                <div v-if="graph.props[0]==='amps'">
                    <v-btn text x-small v-model="a.btn0" :color="a.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="a.btn1" :color="a.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="a.btn2" :color="a.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                </div>
                <v-btn text small @click="refresh"> <v-icon>mdi-refresh</v-icon> </v-btn>
            </v-toolbar>
                <v-card-text>
                    <chart_ v-if="graph.graph == CHART" :data="data" :type="graph.type" :historic="historic != undefined"  height="80%"/>
                    <widget_ v-if="graph.graph == WIDGET" :data="data" :graph="graph"/>
                </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { KWH, COLUMS } from './props-types'
import { mapActions, mapGetters, mapState } from "vuex";
import { CHART, WIDGET } from './props-types'
import { Readings } from '../../api'
import chart_ from './Chart'
import widget_ from './Widget'
export default {
    name: "GraphContainer",
    components: { chart_, widget_ },
    props: ['meter', 'graph', 'historic','width'],
    data() {
        return {
            data: {},
            dataAll: {},
            data15: {},
            data7: {},
            datacurr: {},
            items: [],
            vData: { vm60: {}, vh12: {}, vAll: {} },
            aData: { am60: {}, ah12: {}, aAll: {} },
            wData: { wm60: {}, wh12: {}, wAll: {} },
            kwh: { btn0: true, btn1: false, btn2: false, btn3: false},
            w: { btn0: false, btn1: false, btn2: true},
            v: { btn0: false, btn1: false, btn2: true},
            a: { btn0: false, btn1: false, btn2: true},
            dayRecords: {},
            halfDayRecords: {},
            lastHourRecords: {},
            CHART, WIDGET, KWH, COLUMS
        };
    },
    methods: {
        ...mapActions({ updateMeterDayData: "meters/updateMeterData", getHistoricData: 'meters/getHistoricData' }),
        async refresh() {
            await this.watchReadings()
            if(this.graph.name === 'KWH month') {
                this.items = ['Current Month', '7 days', '15 days', '30 days']
            } else {
                this.items = ['Last hour', '12 hours', '24 hours']
            }
            if(this.historic != undefined) return this.formatChartHistoric()
            if(this.graph.graph == CHART) return this.formatChartData()
            // return this.formatChartData()
            if(this.graph.graph == WIDGET) return this.formatWidgetData()
        },
        formatWidgetData(){
            this.data = this.dataMeter[this.dataMeter.length - 1]
        },
        async formatChartHistoric(){
            this.graph.setType(this.COLUMS)
            const { data } = await this.getHistoricData({
                id_meter: this.meter.name
            })
            let currDate = new Date()
            let currMonth = currDate.getMonth() + 1
            let prevArray = []; let follArray = []

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (data[index]._id.month === currMonth) follArray.push(element)
                else prevArray.push(element)
            }

            let c1 = 0; let c2 = 0

            for (let i = 0; i < prevArray.length-1; i++) {
                c1 += 1
                if (prevArray[i]._id.day > prevArray[i + 1]._id.day) {
                    for (let j = c1; j >= 1; j--) {
                        if (prevArray[j]._id.day < prevArray[j-1]._id.day) {
                            let num = prevArray[j];
                            prevArray[j] = prevArray[j - 1];
                            prevArray[j - 1] = num;
                        }
                    }
                }
            }

            for (let i = 0; i < follArray.length-1; i++) {
                c2 += 1
                if (follArray[i]._id.day > follArray[i + 1]._id.day) {
                    for (let j = c2; j >= 1; j--) {
                        if (follArray[j]._id.day < follArray[j-1]._id.day) {
                            let num = follArray[j];
                            follArray[j] = follArray[j - 1];
                            follArray[j - 1] = num;
                        }
                    }
                }
            }

            // console.log(prevArray);
            // console.log(follArray);

            let newArray = prevArray.concat(follArray)
            // console.log(newArray);
            let array15 = []; let array7 = []
            for (let index = newArray.length - 7; index < newArray.length; index++) {if(newArray[index] != undefined); array7.push(newArray[index]);}
            for (let index = newArray.length - 15; index < newArray.length; index++) {if(newArray[index] != undefined) array15.push(newArray[index]);}
            // console.log(array15);

            const data_formated = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            newArray.forEach( reading => {
                let dt = new Date(reading._id.year, reading._id.month-1, reading._id.day);
                data_formated.series.forEach( serie => {
                    serie.data.push({
                        x: dt.getTime(),
                        y: reading.lines[serie.line][serie.prop].toFixed(2)
                    })
                })      
                data_formated.categories.push(dt.toLocaleDateString())
            })
            this.dataAll = data_formated

            const data_15 = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            // console.log(array15);
            array15.forEach( reading => {
                // console.log(reading);
                let dt = new Date(reading._id.year, reading._id.month-1, reading._id.day);
                data_15.series.forEach( serie => {
                    serie.data.push({
                        x: dt.getTime(),
                        y: reading.lines[serie.line][serie.prop].toFixed(2)
                    })
                })      
                data_15.categories.push(dt.toLocaleDateString())
            })
            this.data15 = data_15

            const data_7 = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            array7.forEach( reading => {
                let dt = new Date(reading._id.year, reading._id.month-1, reading._id.day);
                data_7.series.forEach( serie => {
                    serie.data.push({
                        x: dt.getTime(),
                        y: reading.lines[serie.line][serie.prop].toFixed(2)
                    })
                })      
                data_7.categories.push(dt.toLocaleDateString())
            })
            this.data7 = data_7
            // console.log(this.data7)

            const data_curr = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            follArray.forEach( reading => {
                let dt = new Date(reading._id.year, reading._id.month-1, reading._id.day);
                data_curr.series.forEach( serie => {
                    serie.data.push({
                        x: dt.getTime(),
                        y: reading.lines[serie.line][serie.prop].toFixed(2)
                    })
                })      
                data_curr.categories.push(dt.toLocaleDateString())
            })
            this.datacurr = data_curr
            this.data = this.datacurr
        },
        async formatChartData() { //WATTS,VOLTS,AMPS
            try {
                let actual_time = 0 
                const data_formated = { categories: [], series: [] }
                const data_h12 = { categories: [], series: [] }
                const data_m60 = { categories: [], series: [] }

                if(this.dayRecords){
                    this.graph.lines.forEach( line => {
                        this.graph.props.forEach( prop => {
                            data_formated.series.push({ line, prop, data: [] })
                        })
                    })
                    this.dayRecords.data.forEach( reading => {
                        actual_time = new Date(reading.timestamp)
                        data_formated.series.forEach( serie => {
                            let num = reading.lines[serie.line][serie.prop].toFixed(2)
                            if(serie.prop === 'watts'){
                                num = (num / 1000).toFixed(2)
                            }
                            serie.data.push({
                                x: actual_time.getTime(),
                                y: num
                            })
                        })      
                        data_formated.categories.push(actual_time.toLocaleTimeString().slice(0, -3))
                    })
                    this.data = data_formated
                    
                    if (this.data.series[0].prop === 'watts') { this.wData.wAll = this.data }
                    else if (this.data.series[0].prop === 'volts') { this.vData.vAll = this.data }
                    else { this.aData.aAll = this.data }
                }
                if(this.halfDayRecords){
                    this.graph.lines.forEach( line => {
                        this.graph.props.forEach( prop => {
                            data_h12.series.push({ line, prop, data: [] })
                        })
                    })
                    this.halfDayRecords.data.forEach( reading => {
                        actual_time = new Date(reading.timestamp)
                        data_h12.series.forEach( serie => {
                            let num = reading.lines[serie.line][serie.prop].toFixed(2)
                            if(serie.prop === 'watts'){
                                num = (num / 1000).toFixed(2)
                            }
                            serie.data.push({
                                x: actual_time.getTime(),
                                y: num
                            })
                        })      
                        data_h12.categories.push(actual_time.toLocaleTimeString().slice(0, -3))
                    })
                    if (this.data.series[0].prop === 'watts') { this.wData.wh12 = data_h12 }
                    else if (this.data.series[0].prop === 'volts') { this.vData.vh12 = data_h12 }
                    else { this.aData.vh12 = data_h12 }   
                }
                if(this.lastHourRecords){
                    this.graph.lines.forEach( line => {
                        this.graph.props.forEach( prop => {
                            data_m60.series.push({ line, prop, data: [] })
                        })
                    })
                    this.lastHourRecords.data.forEach( reading => {
                        actual_time = new Date(reading.timestamp)
                        data_m60.series.forEach( serie => {
                            let num = reading.lines[serie.line][serie.prop].toFixed(2)
                            if(serie.prop === 'watts'){
                                num = (num / 1000).toFixed(2)
                            }
                            serie.data.push({
                                x: actual_time.getTime(),
                                y: num
                            })
                        })      
                        data_m60.categories.push(actual_time.toLocaleTimeString().slice(0, -3))
                    })
                    if (this.data.series[0].prop === 'watts') { this.wData.wm60 = data_m60 }
                    else if (this.data.series[0].prop === 'volts') { this.vData.vm60 = data_m60 }
                    else { this.aData.am60 = data_m60 }   
                }

            } catch (error) {
                console.log(error)
            }
        },
        setGraphData(prop, item){
            if (prop === 'kwht') {
                switch (item) {
                    case '7 days': { this.data = this.data7; this.kwh.btn0 = false; this.kwh.btn1 = true; this.kwh.btn2 = false; this.kwh.btn3 = false; break; }
                    case '15 days': { this.data = this.data15; this.kwh.btn0 = false; this.kwh.btn1 = false; this.kwh.btn2 = true; this.kwh.btn3 = false; break; }
                    case 'Current Month': { this.data = this.datacurr; this.kwh.btn0 = true; this.kwh.btn1 = false; this.kwh.btn2 = false; this.kwh.btn3 = false; break; }
                    default: { this.data = this.dataAll; this.kwh.btn0 = false; this.kwh.btn1 = false; this.kwh.btn2 = false; this.kwh.btn3 = true; break; }
                }
            } else if (prop === 'watts') {
                switch (item) { 
                    case 'Last hour': { this.data = this.wData.wm60; this.w.btn0 = true; this.w.btn1 = false; this.w.btn2 = false; console.log(1); break; }
                    case '12 hours': { this.data = this.wData.wh12; this.w.btn0 = false; this.w.btn1 = true; this.w.btn2 = false; console.log(2); break; }
                    default: { this.data = this.wData.wAll; this.w.btn0 = false; this.w.btn1 = false; this.w.btn2 = true; console.log(3); break; }
                }
            } else if (prop === 'volts') {
                switch (item) {
                    case 'Last hour': { this.data = this.vData.vm60; this.v.btn0 = true; this.v.btn1 = false; this.v.btn2 = false; break; }
                    case '12 hours': { this.data = this.vData.vh12; this.v.btn0 = false; this.v.btn1 = true; this.v.btn2 = false; break; }
                    default: { this.data = this.vData.vAll; this.v.btn0 = false; this.v.btn1 = false; this.v.btn2 = true; break; }
                }
            } else {
                switch (item) {
                    case 'Last hour': { this.data = this.aData.am60; this.a.btn0 = true; this.a.btn1 = false; this.a.btn2 = false; break; }
                    case '12 hours': { this.data = this.aData.ah12; this.a.btn0 = false; this.a.btn1 = true; this.a.btn2 = false; break; }
                    default: { this.data = this.aData.aAll; this.a.btn0 = false; this.a.btn1 = false; this.a.btn2 = true; break; }
                }
            }
        },
        async watchReadings(){
            this.dayRecords = await Readings.byMeter(
                { id: this.meter.name, key: this.meter.key },
                { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 24 }
            )
            this.halfDayRecords = await Readings.byMeter(
                { id: this.meter.name, key: this.meter.key },
                { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 12 }
            )
            this.lastHourRecords = await Readings.byMeter(
                { id: this.meter.name, key: this.meter.key },
                { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 1 }
            )
            // console.log(this.dayRecords)
            // console.log(this.halfDayRecords)
            // console.log(this.lastHourRecords)
        }
    },
    mounted() {
        this.refresh()
    },
};
</script>

<style scoped>
div.a {
  text-align: center;
}
.dropdown{
    height: 45px;
    position: relative;
    right: 5px
}
</style>
